// 文件结构：
// /components/TwoDayTimeline/
// ├── TwoDayTimeline.jsx
// └── TwoDayTimeline.css

// TwoDayTimeline.jsx
import React, { useMemo } from 'react';
import './index.css';
import { formatTimeRange, PlanType, PlanTypeColor } from '../../util';
import { Tooltip } from '@maxtropy/components';
import dayjs from 'dayjs';

export interface TimeRange {
  start: string; // "HH:mm"
  end: string; // "HH:mm"
  type: PlanType;
}

interface TwoDayTimelineProps {
  ranges: TimeRange[];
  baseTime: string;
}

const TwoDayTimeline: React.FC<TwoDayTimelineProps> = ({ ranges, baseTime }) => {
  const minutesInTwoDays = 48 * 60;

  const getMinutesFromMidnight = (time: string) => {
    const [h, m] = dayjs(time).format('HH:mm').split(':').map(Number);
    return h * 60 + m;
  };

  const timelineItems = ranges.map((range, index) => {
    let startMinutes = getMinutesFromMidnight(range.start);
    let endMinutes = getMinutesFromMidnight(range.end);

    if (dayjs(range.start).isAfter(baseTime, 'day')) {
      // 跨日处理
      startMinutes += 24 * 60;
    }
    if (dayjs(range.end).isAfter(baseTime, 'day')) {
      // 跨日处理
      endMinutes += 24 * 60;
    }

    const duration = endMinutes - startMinutes;
    const leftPercent = (startMinutes / minutesInTwoDays) * 100;
    const widthPercent = (duration / minutesInTwoDays) * 100;
    console.log('range', range);

    return (
      <Tooltip title={formatTimeRange(baseTime, range.start, range.end)}>
        <div
          key={index}
          className="timeline-block"
          style={{
            left: `${leftPercent}%`,
            width: `${widthPercent}%`,
            backgroundColor: PlanTypeColor[range.type] || 'rgba(74,144,226,0.2)',
          }}
        />
      </Tooltip>
    );
  });

  return (
    <div className="timeline-container horizontal">
      <div className="timeline-content horizontal">{timelineItems}</div>
      <div className="midline" style={{ left: '50%' }} />
      <div className="timeLine-label">
        <div>00:00</div>
        <div>06:00</div>
        <div>12:00</div>
        <div>18:00</div>
        <div>次日00:00</div>
        <div>06:00</div>
        <div>12:00</div>
        <div>18:00</div>
        <div>00:00</div>
      </div>
    </div>
  );
};

export default TwoDayTimeline;
